import React from 'react';
import { Phone, Mail, MapPin, Shield, ChevronUp } from 'lucide-react';
import { businessInfo } from '../../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const quickLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Why Us', href: '#why-us' },
    { label: 'Careers', href: '#careers' },
    { label: 'Coverage', href: '#coverage' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    'Commercial Security',
    'Residential Protection',
    'Event Security',
    'Executive Protection',
  ];

  return (
    <footer className="relative bg-black border-t border-white/10">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <a href="#" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#00D4FF] flex items-center justify-center">
                <span className="text-black font-bold text-lg">AG</span>
              </div>
              <span className="text-white font-semibold text-lg">
                Armed Guard Officer
              </span>
            </a>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Florida's premier licensed armed security service providing elite
              protection for businesses, events, and individuals statewide.
            </p>
            {/* Contact Info */}
            <div className="space-y-3">
              <a
                href={`tel:${businessInfo.phone}`}
                className="flex items-center gap-3 text-gray-400 hover:text-[#00D4FF] transition-colors text-sm"
              >
                <Phone className="w-4 h-4" />
                {businessInfo.phone}
              </a>
              <a
                href={`mailto:${businessInfo.email}`}
                className="flex items-center gap-3 text-gray-400 hover:text-[#00D4FF] transition-colors text-sm"
              >
                <Mail className="w-4 h-4" />
                {businessInfo.email}
              </a>
              <div className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>{businessInfo.address.full}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-gray-500 hover:text-[#00D4FF] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-gray-500 hover:text-[#00D4FF] transition-colors text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Ready to Get Started?</h4>
            <p className="text-gray-500 text-sm mb-6">
              Contact us today for a free security assessment and quote.
            </p>
            <a
              href={`tel:${businessInfo.phone}`}
              className="inline-flex items-center gap-2 bg-[#00D4FF] text-black px-6 py-3 font-semibold text-sm hover:shadow-[0_0_30px_rgba(0,212,255,0.4)] transition-all duration-300"
            >
              <Phone className="w-4 h-4" />
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-gray-600 text-sm">
              <Shield className="w-4 h-4 text-[#00D4FF]" />
              <span>
                © {new Date().getFullYear()} Armed Guard Officer.com. All rights reserved.
              </span>
            </div>
            
            <p className="text-gray-600 text-xs text-center md:text-right max-w-xl">
              Licensed armed security services in compliance with Florida Division of Licensing
              regulations. All officers are fully licensed, insured, and background-verified.
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-[#00D4FF] text-black flex items-center justify-center hover:shadow-[0_0_30px_rgba(0,212,255,0.5)] transition-all duration-300 z-40"
        aria-label="Scroll to top"
      >
        <ChevronUp className="w-6 h-6" />
      </button>
    </footer>
  );
};

export default Footer;
